// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3RsAb","placeholdersHeader":"styles_placeholdersHeader__3f3XA","editorStyle":"styles_editorStyle__3C3cT","placeholdersBox":"styles_placeholdersBox__1Xl6X"};